/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';

import Discuss from 'parts/Discuss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Fade } from "react-awesome-reveal";
import Button from 'elements/Button';

// Replace with your real image path

export default function HospitalityAndTourism() {
  return (
    <>
      {/* CHALLENGES */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold text-center mb-6">Challenges in Hospitality & Tourism</h2>
          <p className="text-center text-gray-600 mb-10">
            Hotels and tourism providers rely on seamless technology to maintain operations, enhance guest experiences,
            and ensure security across all systems.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Guest Wi-Fi & Connectivity</h3>
              <p className="text-gray-600">High-speed, secure Wi-Fi that separates guest traffic from internal business systems.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">POS & Reservation Systems</h3>
              <p className="text-gray-600">Reliable, integrated platforms for booking, payment processing, and service management.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Security & Compliance</h3>
              <p className="text-gray-600">Protection for guest data, PCI-compliant payment systems, and cybersecurity monitoring.</p>
            </div>

          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          <div>
            <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold mb-4">How We Support Hospitality Businesses</h2>
            <ul className="space-y-6 text-gray-600">

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Enhanced Guest Experience</p>
                  <p className="text-sm">Fast connectivity, smooth check-in/out processes, and reliable digital services.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Secure Payment Systems</p>
                  <p className="text-sm">Encrypted, compliant POS systems that protect guest financial data.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Operational Efficiency</p>
                  <p className="text-sm">Integrated communication tools, automation, and cloud solutions that reduce downtime.</p>
                </div>
              </li>

            </ul>

            <div className="mt-6">
              <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Request an IT Assessment</Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6">
            <h3 className="text-xl font-semibold text-theme-blue mb-4">Typical Outcomes</h3>
            <div className="space-y-4 text-gray-600">
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Improved guest satisfaction</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Reduced system outages</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Higher payment security</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Streamlined operations</strong></p>
            </div>
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-light-theme-purple to-white">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-theme-blue font-bold">Want an IT upgrade for your hospitality business?</h2>
            <p className="text-gray-600 mt-2">We help hotels and tourism providers modernize and secure their digital infrastructure.</p>
          </div>

          <div>
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Start Now</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
